import * as tslib_1 from "tslib";
export var ASSIGNMENT_POLICY_TYPE_MICRO_CORRIDOR = 'micro_corridor';
export var MICRO_CORRIDOR_FETCH_BATCH_SIZE = 12;
/** Prefer selected services for supply query; fall back to full city catalog. */
export function resolveServiceDetailIdsForMcListing(selectedService, cityServices) {
    var selected = resolveServiceDetailIdsFromSelection(selectedService);
    if (selected.length > 0) {
        return selected;
    }
    return resolveServiceDetailIdsFromCatalog(cityServices);
}
function modeIdFromServiceRow(row) {
    if (!row || !row.modeInfo) {
        return '';
    }
    var modeId = row.modeInfo._id != null ? row.modeInfo._id : row.modeInfo.id;
    return modeId != null ? String(modeId).trim() : '';
}
/** Mode id for supply workspace MC listing from `/get/services` rows. */
export function resolveModeIdForMcListing(selectedService, cityServices) {
    var sdids = resolveServiceDetailIdsFromSelection(selectedService);
    if (sdids.length === 0 || !cityServices || cityServices.length === 0) {
        return null;
    }
    var modeIds = new Set();
    var _loop_1 = function (sdid) {
        var row = cityServices.find(function (r) { return r && String(r._id) === String(sdid); });
        var modeId = modeIdFromServiceRow(row);
        if (modeId) {
            modeIds.add(modeId);
        }
    };
    for (var _i = 0, sdids_1 = sdids; _i < sdids_1.length; _i++) {
        var sdid = sdids_1[_i];
        _loop_1(sdid);
    }
    if (modeIds.size === 0) {
        return null;
    }
    if (modeIds.size === 1) {
        return Array.from(modeIds)[0];
    }
    var firstRow = cityServices.find(function (r) { return r && String(r._id) === String(sdids[0]); });
    var firstMode = modeIdFromServiceRow(firstRow);
    return firstMode || Array.from(modeIds)[0];
}
function microCorridorNameFromRaw(mc) {
    if (!mc || mc.name == null) {
        return '';
    }
    var s = String(mc.name).trim();
    var id = mc.id != null ? String(mc.id).trim() : '';
    if (!s || (id && s === id)) {
        return '';
    }
    return s;
}
export function attachMicroCorridorDisplayLabels(list) {
    return list.map(function (mc) { return (tslib_1.__assign({}, mc, { displayLabel: formatMicroCorridorOptionLabel(mc) })); });
}
export function parseMicroCorridorsApiResponse(res) {
    var raw = (res && Array.isArray(res.microCorridors))
        ? res.microCorridors
        : ((res && res.data && Array.isArray(res.data.microCorridors)) ? res.data.microCorridors : []);
    var mapped = raw
        .filter(function (mc) { return mc && mc.id; })
        .map(function (mc) { return ({
        id: String(mc.id),
        name: microCorridorNameFromRaw(mc),
        workspace: mc.workspace != null ? String(mc.workspace).trim() : undefined,
        serviceDetails: Array.isArray(mc.serviceDetails) ? mc.serviceDetails : [],
        isRegisteredInSupply: !!mc.isRegisteredInSupply,
        isRegisteredInGeoLayers: !!mc.isRegisteredInGeoLayers,
    }); });
    return attachMicroCorridorDisplayLabels(mapped);
}
export function resolveServiceDetailIdsFromCatalog(cityServices) {
    if (!cityServices || cityServices.length === 0) {
        return [];
    }
    var ids = [];
    for (var _i = 0, cityServices_1 = cityServices; _i < cityServices_1.length; _i++) {
        var row = cityServices_1[_i];
        if (!row) {
            continue;
        }
        var id = row._id != null
            ? String(row._id)
            : (row.service && row.service._id != null ? String(row.service._id) : '');
        if (id.length > 0 && !ids.includes(id)) {
            ids.push(id);
        }
    }
    return ids;
}
/** Service detail ObjectIds from basic-info selectedService rows. */
export function resolveServiceDetailIdsFromSelection(selectedService) {
    if (!selectedService) {
        return [];
    }
    var rows = Array.isArray(selectedService) ? selectedService : [selectedService];
    var ids = [];
    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
        var row = rows_1[_i];
        if (!row) {
            continue;
        }
        var id = row._id != null
            ? String(row._id)
            : (row.service && row.service._id != null ? String(row.service._id) : '');
        if (id.length > 0 && !ids.includes(id)) {
            ids.push(id);
        }
    }
    return ids;
}
/** Global service ids from `POST /api/get/services` rows (dashboard config / slot titles only). */
export function resolveGlobalServiceIdsFromSelection(selectedService) {
    if (!selectedService) {
        return [];
    }
    var rows = Array.isArray(selectedService) ? selectedService : [selectedService];
    var ids = [];
    for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
        var row = rows_2[_i];
        if (!row || !row.service || row.service._id == null) {
            continue;
        }
        var id = String(row.service._id);
        if (id.length > 0 && !ids.includes(id)) {
            ids.push(id);
        }
    }
    return ids;
}
export function chunkServiceDetailIds(ids, batchSize) {
    if (batchSize <= 0 || ids.length === 0) {
        return [];
    }
    var chunks = [];
    for (var i = 0; i < ids.length; i += batchSize) {
        chunks.push(ids.slice(i, i + batchSize));
    }
    return chunks;
}
export function mergeMicroCorridorOptions(lists) {
    var byId = new Map();
    for (var _i = 0, lists_1 = lists; _i < lists_1.length; _i++) {
        var list = lists_1[_i];
        for (var _a = 0, list_1 = list; _a < list_1.length; _a++) {
            var mc = list_1[_a];
            var existing = byId.get(mc.id);
            if (!existing) {
                byId.set(mc.id, tslib_1.__assign({}, mc));
                continue;
            }
            byId.set(mc.id, mergeOneMicroCorridor(existing, mc));
        }
    }
    var merged = Array.from(byId.values()).sort(function (a, b) {
        return (a.name || a.id).localeCompare(b.name || b.id);
    });
    return attachMicroCorridorDisplayLabels(merged);
}
function mergeOneMicroCorridor(a, b) {
    var detailById = new Map();
    var allDetails = (a.serviceDetails || []).concat((b.serviceDetails || []));
    for (var _i = 0, allDetails_1 = allDetails; _i < allDetails_1.length; _i++) {
        var sd = allDetails_1[_i];
        if (sd && sd.id) {
            detailById.set(String(sd.id), sd);
        }
    }
    return {
        id: a.id,
        name: a.name || b.name,
        serviceDetails: Array.from(detailById.values()),
        isRegisteredInSupply: !!(a.isRegisteredInSupply || b.isRegisteredInSupply),
        isRegisteredInGeoLayers: !!(a.isRegisteredInGeoLayers || b.isRegisteredInGeoLayers),
    };
}
export function fetchMicroCorridorsBatched(cityId, serviceDetailIds, fetchBatch, batchSize) {
    if (batchSize === void 0) { batchSize = MICRO_CORRIDOR_FETCH_BATCH_SIZE; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var chunks, parsedBatches, _i, chunks_1, chunk, res, _err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chunks = chunkServiceDetailIds(serviceDetailIds, batchSize);
                    parsedBatches = [];
                    _i = 0, chunks_1 = chunks;
                    _a.label = 1;
                case 1:
                    if (!(_i < chunks_1.length)) return [3 /*break*/, 6];
                    chunk = chunks_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, fetchBatch(cityId, chunk)];
                case 3:
                    res = _a.sent();
                    parsedBatches.push(parseMicroCorridorsApiResponse(res));
                    return [3 /*break*/, 5];
                case 4:
                    _err_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    if (parsedBatches.length === 0) {
                        throw new Error('Failed to fetch micro-corridors');
                    }
                    return [2 /*return*/, mergeMicroCorridorOptions(parsedBatches)];
            }
        });
    });
}
export function formatMicroCorridorOptionLabel(mc) {
    var id = mc && mc.id != null ? String(mc.id).trim() : '';
    var name = mc && mc.name ? String(mc.name).trim() : '';
    if (name && id) {
        return name + " - " + id;
    }
    return name || id;
}
export function microCorridorHasServiceDetails(mc) {
    return !!(mc && mc.serviceDetails && mc.serviceDetails.length > 0);
}
export function matchCityServicesToMicroCorridor(serviceDetails, cityServices) {
    if (!serviceDetails || serviceDetails.length === 0 || !cityServices || cityServices.length === 0) {
        return [];
    }
    var sdIds = new Set(serviceDetails
        .map(function (sd) { return (sd && sd.id ? String(sd.id) : ''); })
        .filter(function (id) { return id.length > 0; }));
    return cityServices.filter(function (row) {
        if (!row) {
            return false;
        }
        var serviceDetailId = row._id != null
            ? String(row._id)
            : (row.service && row.service._id != null ? String(row.service._id) : '');
        return serviceDetailId.length > 0 && sdIds.has(serviceDetailId);
    });
}
export var MC_SIGN_IN_SERVICE_ALLOWLIST_ALL = 'all';
function normalizeAllowlistToken(value) {
    return String(value || '').trim().toLowerCase();
}
/**
 * Config allowlist: `['all']`, service names (e.g. `Link`), or Mongo object ids.
 * Prefer nested `service._id` from `POST /api/get/services` — same across cities.
 * Top-level row `_id` (service detail) and `service.newService` also match for legacy entries.
 */
export function isLogisticsV2IncentiveUiEnabled(allowlist, selectedServices) {
    var entries = (allowlist || [])
        .map(normalizeAllowlistToken)
        .filter(function (token) { return token.length > 0; });
    if (entries.length === 0) {
        return false;
    }
    if (entries.indexOf(MC_SIGN_IN_SERVICE_ALLOWLIST_ALL) !== -1) {
        return true;
    }
    var rows = coerceSelectedServiceRows(selectedServices);
    if (rows.length === 0) {
        return false;
    }
    for (var i = 0; i < rows.length; i++) {
        if (serviceRowMatchesAllowlist(rows[i], entries)) {
            return true;
        }
    }
    return false;
}
/** @deprecated use isLogisticsV2IncentiveUiEnabled */
export var isMcSignInIncentiveUiEnabled = isLogisticsV2IncentiveUiEnabled;
export function resolveLogisticsV2IncentiveServiceAllowlist(env) {
    // Delegates to logistics-v2-incentive.config when imported there; keep local fallback for tests.
    var block = env.logisticsV2Incentive;
    if (block && block.enabledServices && block.enabledServices.length) {
        return block.enabledServices;
    }
    var primary = env.logisticsV2IncentiveEnabledServices;
    return primary && primary.length ? primary : ['all'];
}
var LOGISTICS_V2_KNOWN_INCENTIVE_TYPES = new Set([
    'Daily',
    'Weekly Fixed',
    'Adhoc',
]);
/** Maps config shorthand to payroll-dash / API incentive type labels. */
export function normalizeLogisticsV2IncentiveTypeToken(token) {
    var trimmed = String(token || '').trim();
    if (!trimmed) {
        return null;
    }
    if (LOGISTICS_V2_KNOWN_INCENTIVE_TYPES.has(trimmed)) {
        return trimmed;
    }
    var lower = trimmed.toLowerCase();
    if (lower === 'weekly' || lower === 'weekly fixed') {
        return 'Weekly Fixed';
    }
    if (lower === 'daily') {
        return 'Daily';
    }
    if (lower === 'adhoc') {
        return 'Adhoc';
    }
    return null;
}
/** Incentive types selectable when incentive version v2 is chosen. Defaults to Daily only. */
export function resolveLogisticsV2AllowedIncentiveTypes(configured) {
    var cfg = configured;
    if (!cfg || !cfg.length) {
        return ['Daily'];
    }
    var seen = new Set();
    var allowed = [];
    for (var i = 0; i < cfg.length; i++) {
        var normalized = normalizeLogisticsV2IncentiveTypeToken(cfg[i]);
        if (!normalized || seen.has(normalized)) {
            continue;
        }
        seen.add(normalized);
        allowed.push(normalized);
    }
    return allowed.length ? allowed : ['Daily'];
}
export function isLogisticsV2IncentiveTypeAllowed(type, allowed) {
    if (!type) {
        return false;
    }
    return allowed.indexOf(type) !== -1;
}
export function formatLogisticsV2AllowedIncentiveTypes(allowed) {
    if (!allowed || !allowed.length) {
        return 'Daily only';
    }
    if (allowed.length === 1) {
        return allowed[0] + " only";
    }
    var last = allowed[allowed.length - 1];
    var rest = allowed.slice(0, -1);
    return rest.join(', ') + " and " + last;
}
function coerceSelectedServiceRows(selected) {
    if (!selected) {
        return [];
    }
    if (selected instanceof Array) {
        return selected.filter(function (row) { return !!row; });
    }
    return [];
}
function looksLikeMongoObjectId(token) {
    return /^[a-f0-9]{24}$/i.test(token);
}
function collectServiceObjectIdTokens(row) {
    var tokens = [];
    if (!row) {
        return tokens;
    }
    if (row._id != null) {
        tokens.push(normalizeAllowlistToken(String(row._id)));
    }
    if (row.service) {
        if (row.service._id != null) {
            tokens.push(normalizeAllowlistToken(String(row.service._id)));
        }
        if (row.service.newService != null) {
            tokens.push(normalizeAllowlistToken(String(row.service.newService)));
        }
    }
    return tokens;
}
function serviceRowMatchesAllowlist(row, entries) {
    if (!row) {
        return false;
    }
    var objectIdTokens = collectServiceObjectIdTokens(row);
    var nameTokens = collectServiceNameTokens(row);
    for (var e = 0; e < entries.length; e++) {
        var entry = entries[e];
        if (looksLikeMongoObjectId(entry)) {
            if (objectIdTokens.indexOf(entry) !== -1) {
                return true;
            }
            continue;
        }
        if (nameTokens.indexOf(entry) !== -1) {
            return true;
        }
    }
    return false;
}
function collectServiceNameTokens(row) {
    var tokens = [];
    if (!row || !row.service) {
        return tokens;
    }
    var svc = row.service;
    if (svc.name) {
        tokens.push(normalizeAllowlistToken(String(svc.name)));
    }
    if (svc.shortName) {
        tokens.push(normalizeAllowlistToken(String(svc.shortName)));
    }
    if (svc.displayName) {
        tokens.push(normalizeAllowlistToken(String(svc.displayName)));
    }
    return tokens;
}
